<template>
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">{{ label }}</label>
    </div>
    <div class="field-body">
      <div class="field is-grouped" :class="{ 'multi-line': isFullWidth }">
        <div class="control" :class="{ 'full-width': isFullWidth }">
          <slot />
        </div>
        <slot name="right" class="control" />
        <slot
          name="message"
          class="control field-message"
          :class="{ offset: !isFullWidth }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "field-horizontal",
  props: ["label", "isFullWidth"]
}
</script>

<style lang="scss">
.full-width {
  width: 100%;
}
.multi-line {
  flex-wrap: wrap;
}
.offset {
  margin-left: 0.5rem;
}
</style>
